import React, { useEffect, useState } from "react";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import styled from "styled-components";
import Dots from "../../../assets/GIFs/dotss.gif";
import { year, ENVIRONMENT } from "../Shared Utils/InputConstants";
import CustomDatePicker from "../Shared Utils/CustomDatePicker";

export default function CompositeLineChart({
  data,
  data2,
  label,
  label2,
  fields,
  fields2,
  filter,
  filterType,
  style,
  chart_options,
}) {
  const [recievedData, setReceivedData] = useState([]);
  const [recievedLabel, setReceivedLabel] = useState([]);
  const [recievedAmount, setReceivedAmount] = useState([]);
  const [loading, setLoading] = useState(true);
  const dataGridFilterParams = chart_options.defaultFilterParams;

  const backgroundColor = [
    "#1f77b4",
    "#5cb85c",
  ];
  let count = 0;

  useEffect(() => {
    if(data.length>0 && data2.length>0)
      reload();
  }, [data, data2]);

  const onChangeDatePicker = (dates) => {
    Object.keys(dates).forEach((key) => {
      dataGridFilterParams[key] = dates[key];
    });
    reload();
  };

  function reload() {
    setLoading(true);
    const dataValue = [];
    const dataLabel = [];

    data?.length > 0 &&
      label?.map((l, index) => {
        let temp = {
          label: l,
          data: [],
          backgroundColor: "#d2e4f0",
          fill: true,
          borderColor: "#3584bb",
        };
        data.map((el, index1) => {
          temp.data.push(el[fields[index]]?.toString());
          if (dataLabel.indexOf(el[chart_options.option]) < 0) {
            dataLabel.push(el[chart_options.option]);
            setLoading(false);
          }
        });
        dataValue.push(temp);
      });
      data2?.length > 0 &&
      label2?.map((l, index) => {
        let temp = {
          label: l,
          data: [...data.map(() => null)],
          backgroundColor: "#ffe5cf",
          fill: true,
          borderColor: "#ff7f0e",
        };
        data2.map((el, index1) => {
          temp.data.push(el[fields2[index]]?.toString());
          if (dataLabel.indexOf(el[chart_options.option]) < 0) {
            dataLabel.push(el[chart_options.option]);
            setLoading(false);
          }
        });
        dataValue.push(temp);
      });

    setReceivedLabel(dataLabel);
    setReceivedData(dataValue);
  }
  const options = {
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: "x",
    animations: {
      tension: {
        duration: 1000,
        easing: "easeOutExpo",
        from: 1,
        to: 0,
        loop: true,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        stacked: true,
        ticks: {
          autoSkip: false,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const dataset = {
    labels: [...recievedLabel],
    datasets: [...recievedData],
  };
  return (
    <Wrapper>
      <div style={style}>
        <Line options={options} data={dataset} plugins={ChartDataLabels} />
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  .select {
    width: 6rem;
  }
`;
